import React from "react";
import { Copy, ShoppingCart, LineChart, Check } from "lucide-react";
import { toast } from "sonner";
import { LINKS, CONTRACT_ADDRESS } from "@/lib/constants";
import { cn } from "@/lib/utils";

const XIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const XLink = ({ className = "", size = 18 }) => (
  <a
    href={LINKS.x}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="CLAWNET on X"
    data-testid="x-link"
    className={cn("inline-flex items-center justify-center rounded-lg border border-white/10 bg-white/5 p-2 text-slate-200 transition-colors hover:border-cyan-400/40 hover:text-cyan-300", className)}
  >
    <XIcon className="h-[18px] w-[18px]" />
  </a>
);

export const CAButton = ({ className = "" }) => {
  const [copied, setCopied] = React.useState(false);
  const onClick = () => {
    if (CONTRACT_ADDRESS) {
      navigator.clipboard?.writeText(CONTRACT_ADDRESS);
      setCopied(true);
      toast.success("Contract address copied");
      setTimeout(() => setCopied(false), 1500);
    } else {
      toast("Contract address — Coming Soon", { description: "CA will be published at launch." });
    }
  };
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="ca-button"
      aria-disabled={!CONTRACT_ADDRESS}
      className={cn("inline-flex items-center gap-1.5 rounded-lg border border-white/10 bg-white/5 px-3 py-2 font-mono text-xs font-semibold text-slate-300 transition-colors hover:border-cyan-400/40 hover:text-cyan-200", className)}
    >
      {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
      CA: {CONTRACT_ADDRESS ? `${CONTRACT_ADDRESS.slice(0, 6)}…${CONTRACT_ADDRESS.slice(-4)}` : "COMING SOON"}
    </button>
  );
};

export const BuyButton = ({ className = "", full = false }) => (
  <a
    href={LINKS.buy}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="buy-button"
    className={cn("inline-flex items-center justify-center gap-1.5 rounded-lg bg-cyan-400 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#050814] transition-all hover:bg-cyan-300 btn-glow", full && "w-full", className)}
  >
    <ShoppingCart className="h-4 w-4" /> Buy CLAWNET
  </a>
);

export const ChartButton = ({ className = "", full = false }) => (
  <a
    href={LINKS.chart}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="chart-button"
    className={cn("inline-flex items-center justify-center gap-1.5 rounded-lg border border-white/10 bg-white/5 px-4 py-2 text-xs font-bold uppercase tracking-wide text-white transition-colors hover:border-cyan-400/40 hover:text-cyan-200", full && "w-full", className)}
  >
    <LineChart className="h-4 w-4" /> View Chart
  </a>
);

export const CryptoBar = ({ className = "" }) => (
  <div className={cn("flex items-center gap-2", className)}>
    <XLink />
    <CAButton />
    <BuyButton />
    <ChartButton />
  </div>
);

export default CryptoBar;
